// useGlobalStore.js
import { create } from 'zustand';


export interface GlobalState {
  isMutating: boolean;
  currentState: string;
  isLoggingOut: boolean;
  logoutMessage: string;
  isNavBarCollapsed:boolean;
  setCurrentState: (currentState:string) => void;
  setIsMutating: (isMutating: any) => void;
  setIsLoggingOut: (isLoggingOut: boolean) => void;
  setNavBarCollapsed:(isNavBarCollapsed:boolean) =>void;
  isAivaOpen:boolean,
  setAivaOpen:(isAivaOpen:boolean) =>void;
  isAivaMinimized:boolean,
  setAivaMinimized:(isAivaMinimized:boolean) =>void;
  isAhaLoaded:boolean,
  setAhaLoaded:(isAhaLoaded:boolean) =>void;
  setLogoutMessage:(logoutMessage:string) => void;
  setSSEConnected:(isSSEConnected:boolean) => void;
  isSSEConnected:boolean;
}

export const useGlobalStore = create<GlobalState>((set) => ({
  isMutating: false,
  setIsMutating: (val:boolean) => set({ isMutating: val }),
  currentState:'',
  setCurrentState: (val:string) => set({ currentState: val }),
  isLoggingOut:false,
  setIsLoggingOut: (isLoggingOut:boolean) => set({ isLoggingOut }),
  isNavBarCollapsed:false,
  setNavBarCollapsed: (isNavBarCollapsed:boolean) => set({ isNavBarCollapsed }),
  isAivaOpen:false,
  setAivaOpen: (isAivaOpen:boolean) => set({ isAivaOpen }),
  isAivaMinimized:false,
  setAivaMinimized: (isAivaMinimized:boolean) => set({ isAivaMinimized }),
  isAhaLoaded:false,
  setAhaLoaded: (isAhaLoaded:boolean) => set({ isAhaLoaded }),
  logoutMessage: '',
  setLogoutMessage: (logoutMessage:string) => set({ logoutMessage }),
  setSSEConnected: (isSSEConnected:boolean) => set({ isSSEConnected }),
  isSSEConnected:false,
}));
